import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { VerifiedStatus } from '../models/account';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthenticationService,
    private router: Router) {

  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.authService.isLogged()) {
      this.authService.logout();
      this.router.navigate(['/']);
      return false;
    } else {
      const data = this.authService.getAccountStatusData();
      if (data === undefined || data === null) {
        this.authService.logout();
        this.router.navigate(['/']);
        return false;
      }
      if (data.verified_status === VerifiedStatus.Created) {
        this.router.navigate(['/account/submit-activation']);
        return false;
      } else if (data.verified_status === VerifiedStatus.Submitted) {
        this.authService.logout();
        this.router.navigate(['/account/wait-activation']);
        return false;
      } else {
        if (!data.already_set_limit || !data.already_set_pin) {
          this.router.navigate(['/security/set-pin-limit']);
          return false;
        }
      }
    }
    return true;
  }

  canActivateChild(): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate();
  }
}
